import { useSelector } from 'react-redux';
import DropDown from '@/components/forms/new/formikFormFields/DropDown';
import TrunkFieldRow from './TrunkFieldRow';

const SRTRegionField = ({
    value,
    options,
    onChange,
    onBlur,
    isInvalid,
    isReadOnly = false,
}) => {
    const { darkMode } = useSelector((state) => state.settings);

    return (
        <TrunkFieldRow
            label="Region"
            tooltip={
                isReadOnly
                    ? 'The region a trunk is provisioned in cannot be changed'
                    : 'The region this trunk will be provisioned in'
            }
            ariaLabel="region-tip"
            isInvalid={isInvalid}>
            <DropDown
                field={{ value }}
                data={options}
                shownValue="name"
                selectedId="id"
                name="regionID"
                currentId={value}
                readOnly={isReadOnly}
                handleSelectChange={(item) => onChange(item?.id || '')}
                onBlur={onBlur}
                placeholder="Select a region"
                darkMode={darkMode}
                width="100%"
            />
        </TrunkFieldRow>
    );
};

export default SRTRegionField;
